import React from "react";

import { Button, FlexColumn, Modal, Typography } from "../../../components";
import { COLORS } from "../../../constants";

// 18px, the title's size, and a block element so it centers on the title (10/6 review: the 20px
// inline icon looked too big and sat off the title's center line).
const GreenCheck: React.FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block", flexShrink: 0 }}
  >
    <circle cx="10" cy="10" r="10" fill="#16B364" />
    <path
      d="M5.8 10.2l2.6 2.6 5.8-5.9"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

type Props = {
  visible: boolean;
  // Grey subtext -- differs per flow (Contact Sales vs Request License).
  message: React.ReactNode;
  onClose: () => void;
};

// ENG-8924: the "Request Sent" confirmation after Contact Sales or Request License on the Plans &
// Billing gate pages (Figma: green check + title, grey message, "Got it"). Matches the add-on's.
export const RequestSentModal: React.FC<Props> = ({ visible, message, onClose }) => (
  <Modal visible={visible} onCancel={onClose} width={240} centered closable>
    <FlexColumn gap={2}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <GreenCheck />
        <Typography variant={"h6"} fontWeight={"bold"}>
          Request Sent
        </Typography>
      </div>
      <Typography variant={"body2"} style={{ color: COLORS.black50 }}>
        {message}
      </Typography>
      <Button type={"primary"} onClick={onClose}>
        Got it
      </Button>
    </FlexColumn>
  </Modal>
);
